// @ts-nocheck
import Component from '@glimmer/component'
import { action } from '@ember/object'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'

export default class HookInspectorComponent extends Component {
  @action
  triggerHook(hook: string) {
    this.args.triggerHook?.(this.args.step, hook)
  }

  <template>
    <div data-testid='flow-kit__toolbar__actions' class='flex w-full flex-col p-4'>
      <h2 class='text-xbold-para-16 mb-3 text-neutrals-400'>Hooks</h2>

      {{#if @step}}
        <div class='flex w-full flex-col gap-2'>
          <button
            class='rounded-3 text-reg-para-14 w-full cursor-pointer border border-neutrals-200 bg-neutrals-50 px-3 py-2 text-left text-neutrals-400 transition-colors hover:border-theme-300 hover:bg-theme-50 hover:text-theme-300'
            {{on 'click' (fn this.triggerHook 'onStepMounted')}}
          >onStepMounted</button>
          <button
            class='rounded-3 text-reg-para-14 w-full cursor-pointer border border-neutrals-200 bg-neutrals-50 px-3 py-2 text-left text-neutrals-400 transition-colors hover:border-theme-300 hover:bg-theme-50 hover:text-theme-300'
            {{on 'click' (fn this.triggerHook 'canAdvanceStep')}}
          >canAdvanceStep</button>
          <button
            class='rounded-3 text-reg-para-14 w-full cursor-pointer border border-neutrals-200 bg-neutrals-50 px-3 py-2 text-left text-neutrals-400 transition-colors hover:border-theme-300 hover:bg-theme-50 hover:text-theme-300'
            {{on 'click' (fn this.triggerHook 'onFlowUpdated')}}
          >onFlowUpdated</button>
          <button
            class='rounded-3 text-reg-para-14 w-full cursor-pointer border border-neutrals-200 bg-neutrals-50 px-3 py-2 text-left text-neutrals-400 transition-colors hover:border-theme-300 hover:bg-theme-50 hover:text-theme-300'
            {{on 'click' (fn this.triggerHook 'canAdvancePage')}}
          >canAdvancePage</button>
          <button
            class='rounded-3 text-reg-para-14 w-full cursor-pointer border border-neutrals-200 bg-neutrals-50 px-3 py-2 text-left text-neutrals-400 transition-colors hover:border-theme-300 hover:bg-theme-50 hover:text-theme-300'
            {{on 'click' (fn this.triggerHook 'onErrorCaptured')}}
          >onErrorCaptured</button>
        </div>
      {{else}}
        <div class='rounded-3 border border-neutrals-200 bg-neutrals-50 p-3 text-center'>
          <span class='text-reg-para-14 text-neutrals-300'>Select a step to trigger hooks</span>
        </div>
      {{/if}}
    </div>
  </template>
}
